
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiAlertDialog extends Serenity.EntityDialog<UtentiProdottiAlertRow, any> {
        protected getFormKey() { return UtentiProdottiAlertForm.formKey; }
        protected getIdProperty() { return UtentiProdottiAlertRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiAlertRow.localTextPrefix; }
        protected getNameProperty() { return UtentiProdottiAlertRow.nameProperty; }
        protected getService() { return UtentiProdottiAlertService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiAlertRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiAlertRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiAlertRow.updatePermission; }

        protected form = new UtentiProdottiAlertForm(this.idPrefix);

    }
}